<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import PortalEmptyState from 'dashboard/components-next/HelpCenter/EmptyState/Portal/PortalEmptyState.vue';
import { resolveHelpCenterSetupIntentLabel } from '../helpers/portalSetupIntent';

const route = useRoute();
const { t } = useI18n();

const intendedNavigationPath = computed(() => {
  const queryValue = route.query?.intendedNavigationPath;
  return Array.isArray(queryValue) ? queryValue[0] : queryValue;
});

const intendedNavigationLabel = computed(() =>
  resolveHelpCenterSetupIntentLabel(intendedNavigationPath.value, t)
);
</script>

<template>
  <div class="w-full h-full bg-n-background">
    <PortalEmptyState :intended-navigation-label="intendedNavigationLabel" />
  </div>
</template>
